import { createSystemDefined } from '../../app/services/Storage/CreateSystemDefined'
import { createUserSystemDefined } from '../../app/services/Storage/CreateUserSystemDefined'
import { getAllInternalRecycleBin } from '../../app/services/Storage/GetAll_InternalRecycleBin'
import { restoreInternalRecycleBin } from '../../app/services/Storage/Restore_InternalRecycleBin'
import { getSystemDefinedDirStorage } from '../../app/services/Storage/getSystemDefinedDirStorage'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from './app'

export const getSystemDirStorage = (suborganizationId, userId) => {
  return async (dispatch) => {
    try {
      const response = await getSystemDefinedDirStorage(
        suborganizationId,
        userId
      )
      return response.data.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: StorageAPI'
          )
        )
      }
      return null
    }
  }
}
// ---------------------
// INTERNAL RECYCLE
// ---------------------

// request get recycle by params
export const getInternalRecycle = (params) => {
  return async (dispatch) => {
    try {
      const response = await getAllInternalRecycleBin(params)
      return response.data?.data?.childrens
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: StorageAPI'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en el servicio: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      // error
      return []
    }
  }
}

// NO ME FUNCIONÓ EL ERROR

export const restoreDocuments = (ids) => {
  return async (dispatch) => {
    try {
      await restoreInternalRecycleBin(ids)
      const alertSuccess =
        'Documento' +
        (ids.length > 1 ? 's' : '') +
        ' restaurado' +
        (ids.length > 1 ? 's' : '') +
        ' con éxito'

      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar(alertSuccess))
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: StorageApi'
          )
        )
      }
    }
  }
}

// Create system directories

export const createSystemDirectories = (body) => {
  return async (dispatch) => {
    try {
      const response = await createSystemDefined(body)
      return response.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: StorageAPI'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en el servicio: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      // error
      return []
    }
  }
}

// Create user system directories

export const createUserSystemDirectories = (body) => {
  return async (dispatch) => {
    try {
      const response = await createUserSystemDefined(body)
      return response.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: StorageAPI'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en el servicio: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      // error
      return []
    }
  }
}
